import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import * as CommonAction from '../../actions/Common.actions';
import '../../styles/main.scss';
import '../../styles/components/options/editPopup.animation.scss';
import closeBtn from '../../assets/popup_close.svg';
import Button from '../Button';
import '../../styles/components/options/popups/edit_popup_content.scss';

const DialogBox = ({ dialogs }) => {
	const [dialog, setdialog] = useState({
		appAlert: false,
		title: '',
		msg: '',
		leftBtn: '',
		rightBtn: '',
		handleEditState: () => {},
		leftAction: () => {},
		rightAction: () => {},
	});

	const handleResp = () => {
		document.querySelector('.popup_wrapper')?.classList.add('scale-out-center'); //animation
		setTimeout(() => {
			dialog?.handleEditState?.();
			setactive(false);
		}, 100);
	};

	useEffect(() => {
		showDialogs();
	}, [dialogs]);

	const [dismissedDialgs, setdismissedDialgs] = useState(0);
	const [active, setactive] = useState(false);

	const showDialogs = () => {
		const newDialog = dialogs[dialogs.length - 1 - dismissedDialgs];

		if (active || !newDialog) return;

		setdialog({ dialog, ...newDialog });
		setactive(true);
		setdismissedDialgs(dismissedDialgs + 1);
	};

	if (!active) {
		return <></>;
	}

	return (
		<div className='modal_container' style={{ display: 'flex' }}>
			<div className='popup_wrapper scale-up-center'>
				<div className='popup_title_wrapper'>
					<div className='popup_title'>
						{dialog?.title ? dialog?.title : 'Are you sure?'}
					</div>
					<div className='close_popup'>
						<img src={closeBtn} alt='' onClick={handleResp} />
					</div>
				</div>
				<div className='edit_name_container'>
					{dialog?.msg && <span className='d-msg'>{dialog?.msg}</span>}
					<div className='dialog-btn-set'>
						{dialog?.leftBtn && (
							<Button
								labal={dialog?.leftBtn}
								style={dialog?.appAlert ? { backgroundColor: 'red' } : {}}
								onClickEvent={() => {
									handleResp();
									dialog?.leftAction?.();
								}}
								className='d-btn'
							></Button>
						)}
						{dialog?.rightBtn && (
							<Button
								labal={dialog?.rightBtn}
								onClickEvent={() => {
									handleResp();
									dialog?.rightAction?.();
								}}
								className='d-btn'
							></Button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
const mapStateToProps = ({ common }) => ({
	dialogs: common?.dialogs,
});

const mapDispatchToProps = {
	showDialog: CommonAction.showDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(DialogBox);
